// import styled from 'styled-components';
// import { darken, lighten } from 'polished';

// /**
//  * A altura fixa de 900px foi trocada por 100%: com a tela de Mapeamento
//  * usando altura de viewport, o valor fixo forçava a rolagem do painel
//  * mesmo com poucos itens e desperdiçava espaço.
//  */
// export const Wrapper = styled.div`
//   flex: 1;
//   padding: 10px;
//   height: 100%;
//   min-height: 0;
//   overflow: auto;
// `;

// export const Table = styled.table`
//   padding: 10px 0;
//   border-collapse: collapse;
//   width: 100%;

//   th,
//   td {
//     padding: 8px 2px;
//     text-align: center;
//     border-bottom: 1px solid #ddd;

//     button {
//       border: none;
//       background: none;
//       align-items: center;
//       transition: color 0.5s;

//       :hover {
//         color: #ff6d3c;
//       }
//     }

//     &:nth-of-type(3) {
//       box-sizing: content-box;

//       margin: 0;
//       padding: 0;
//       align-items: center;

//       button {
//         border: none;
//         background: none;
//       }
//     }
//   }
// `;

// export const TableRow = styled.tr`
//   background: ${({ highlighted }) =>
//     highlighted ? lighten(0.1, '#538061') : '#fff'};

//   .linkSvg {
//     color: ${({ highlighted }) =>
//       highlighted ? '#f5f5f5' : darken(0.2, '#f5f5f5')};
//   }

//   :hover {
//     background: ${({ linked }) =>
//       linked ? lighten(0.1, '#538061') : darken(0.1, '#f5f5f5')};

//     .linkSvg {
//       color: ${({ linked }) => (linked ? '#f5f5f5' : darken(0.2, '#f5f5f5'))};
//     }
//   }
// `;

// export const HeaderOptions = styled.th`
//   button {
//     padding: 0;
//   }

//   /**
//    * Com mais de um botão no cabeçalho eles ficam lado a lado, mas o flex
//    * vai em um <div> interno: aplicar display:flex no próprio <th> tira a
//    * célula do layout de tabela e desalinha as colunas.
//    */
//   > div {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     gap: 8px;
//   }

//   button[aria-pressed='true'] {
//     color: #de3b3b;
//   }
// `;

// /**
//  * =====================================================================
//  * EXCLUSÃO EM LOTE
//  * ---------------------------------------------------------------------
//  * A coluna de seleção e a barra de confirmação só existem enquanto o
//  * modo de exclusão está ligado; fora dele a tabela fica exatamente como
//  * era antes.
//  * =====================================================================
//  */

// /** coluna estreita do checkbox, à esquerda de cada item */
// export const CheckCell = styled.td`
//   width: 30px;
//   padding: 0 !important;
//   text-align: center !important;
// `;

// export const CheckHeader = styled.th`
//   width: 30px;
//   padding: 0 !important;
//   text-align: center !important;
// `;

// /**
//  * Barra de ação do modo de exclusão. Fica grudada no topo da coluna
//  * para continuar acessível enquanto o usuário rola a lista de itens.
//  */
// export const BarraExclusao = styled.div`
//   position: sticky;
//   top: 0;
//   z-index: 2;

//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 8px;
//   flex-wrap: wrap;

//   margin-bottom: 8px;
//   padding: 8px 10px;

//   background: #fff5f5;
//   border: 1px solid #f7c6c6;
//   border-radius: 10px;

//   > strong {
//     font-size: 12px;
//     color: #8c2f2f;
//   }

//   > div {
//     display: flex;
//     align-items: center;
//     gap: 6px;
//   }

//   button {
//     display: inline-flex;
//     align-items: center;
//     gap: 5px;

//     padding: 6px 10px;

//     font-size: 12px;
//     font-weight: 600;

//     border: 1px solid #d8e0eb;
//     border-radius: 8px;
//     background: #fff;
//     color: #475569;
//     cursor: pointer;

//     &:hover:not(:disabled) {
//       background: #f1f5f9;
//     }

//     &.perigo {
//       color: #fff;
//       background: #de3b3b;
//       border-color: transparent;

//       &:hover:not(:disabled) {
//         background: #c53030;
//       }
//     }

//     &:disabled {
//       opacity: 0.5;
//       cursor: not-allowed;
//     }
//   }
// `;

// export const RowOptions = styled.td`
//   padding: 8px 2px;

//   button {
//     padding: 0;
//   }
// `;

import styled, { css } from 'styled-components';
import { darken, lighten } from 'polished';

/**
 * Área rolável da tabela de itens.
 *
 * Este componente é usado por DUAS telas com layouts diferentes:
 *
 *  - Mapeamento (alturaTotal): o pai tem altura de viewport definida,
 *    então a tabela preenche exatamente o espaço disponível. A altura
 *    fixa de 900px ali forçava rolagem mesmo com poucos itens.
 *
 *  - Extração (padrão): o pai não tem altura, então a tabela mantém o
 *    teto de 900px de sempre. Com "height: 100%" contra pai sem altura
 *    o valor resolve para auto e a lista cresce sem limite, empurrando
 *    o conteúdo para fora da moldura branca do cartão.
 */
export const Wrapper = styled.div`
  flex: 1;
  padding: 10px;
  overflow: auto;

  ${(props) =>
    props.alturaTotal
      ? css`
          height: 100%;
          min-height: 0;
        `
      : css`
          height: 900px;
        `}
`;

export const Table = styled.table`
  padding: 10px 0;
  border-collapse: collapse;
  width: 100%;

  th,
  td {
    padding: 8px 2px;
    text-align: center;
    border-bottom: 1px solid #ddd;

    button {
      border: none;
      background: none;
      align-items: center;
      transition: color 0.5s;

      :hover {
        color: #ff6d3c;
      }
    }

    &:nth-of-type(3) {
      box-sizing: content-box;

      margin: 0;
      padding: 0;
      align-items: center;

      button {
        border: none;
        background: none;
      }
    }
  }
`;

export const TableRow = styled.tr`
  background: ${({ highlighted }) =>
    highlighted ? lighten(0.1, '#538061') : '#fff'};

  .linkSvg {
    color: ${({ highlighted }) =>
      highlighted ? '#f5f5f5' : darken(0.2, '#f5f5f5')};
  }

  :hover {
    background: ${({ linked }) =>
      linked ? lighten(0.1, '#538061') : darken(0.1, '#f5f5f5')};

    .linkSvg {
      color: ${({ linked }) => (linked ? '#f5f5f5' : darken(0.2, '#f5f5f5'))};
    }
  }
`;

export const HeaderOptions = styled.th`
  button {
    padding: 0;
  }

  /**
   * Com mais de um botão no cabeçalho eles ficam lado a lado, mas o flex
   * vai em um <div> interno: aplicar display:flex no próprio <th> tira a
   * célula do layout de tabela e desalinha as colunas.
   */
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  button[aria-pressed='true'] {
    color: #de3b3b;
  }
`;

/**
 * =====================================================================
 * EXCLUSÃO EM LOTE
 * ---------------------------------------------------------------------
 * A coluna de seleção e a barra de confirmação só existem enquanto o
 * modo de exclusão está ligado; fora dele a tabela fica exatamente como
 * era antes.
 * =====================================================================
 */

/** coluna estreita do checkbox, à esquerda de cada item */
export const CheckCell = styled.td`
  width: 30px;
  padding: 0 !important;
  text-align: center !important;
`;

export const CheckHeader = styled.th`
  width: 30px;
  padding: 0 !important;
  text-align: center !important;
`;

/**
 * Barra de ação do modo de exclusão. Fica grudada no topo da coluna
 * para continuar acessível enquanto o usuário rola a lista de itens.
 */
export const BarraExclusao = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;

  margin-bottom: 8px;
  padding: 8px 10px;

  background: #fff5f5;
  border: 1px solid #f7c6c6;
  border-radius: 10px;

  > strong {
    font-size: 12px;
    color: #8c2f2f;
  }

  > div {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  button {
    display: inline-flex;
    align-items: center;
    gap: 5px;

    padding: 6px 10px;

    font-size: 12px;
    font-weight: 600;

    border: 1px solid #d8e0eb;
    border-radius: 8px;
    background: #fff;
    color: #475569;
    cursor: pointer;

    &:hover:not(:disabled) {
      background: #f1f5f9;
    }

    &.perigo {
      color: #fff;
      background: #de3b3b;
      border-color: transparent;

      &:hover:not(:disabled) {
        background: #c53030;
      }
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;

export const RowOptions = styled.td`
  padding: 8px 2px;

  button {
    padding: 0;
  }
`;
